import React, {useEffect} from 'react'
export const useResize = (handler) => {
    useEffect(() => {
      window.addEventListener("resize", handler);
  
      return () => {
        window.removeEventListener("resize", handler);
      };
    }, [handler]);
  };